import React from 'react';
import { Box, CircularProgress } from '@mui/material';

/**
 * Full-screen loading overlay with a blur effect.
 * Usage: <LoadingOverlay open={isLoading} />
 */
export default function LoadingOverlay({ open }) {
    if (!open) return null;

    return (
        <Box
            sx={{
                position: 'fixed',
                inset: 0,
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backdropFilter: 'blur(4px)',
                WebkitBackdropFilter: 'blur(4px)',
                bgcolor: 'rgba(255, 255, 255, 0.45)',
            }}
        >
            <CircularProgress size={48} thickness={4} />
        </Box>
    );
}
